"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _reactRouterDom = require("react-router-dom");
var _routeTemplates = require("../../routeTemplates");
var _path = _interopRequireDefault(require("../../helpers/path"));
require("./SubNavRowComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SubNavRowClasses = (0, _cssClassesHelper.getBEMClasses)('sub-nav-row');
var SubNavRowComponent = function SubNavRowComponent(_props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: SubNavRowClasses()
  }, _routeTemplates.subNavOptions.subNavItems.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
      exact: true,
      key: link.path,
      to: (0, _path["default"])(link.path),
      className: SubNavRowClasses('item'),
      activeClassName: SubNavRowClasses('item', 'selected')
    }, t(link.text));
  }));
};
var _default = exports["default"] = SubNavRowComponent;